<div class="content-container page-body">
  <div class="go-to-all" *ngIf="pageJson?.isDisplayDepositButton">
    <a class="button-all-promotion" [routerLink]="promotionsTrx" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <img src="{{licenceConfigService.getKey('icon-right')}}" alt="yellow-arrow" icon-btn direction="left">
      <span i18n>All Promotions</span>
    </a>
  </div>
  <ng-container *ngIf="pageJson?.desktopHeaderBanner && !isVipPage">
    <div fxLayoutAlign="center center" fxLayout="column" class="top-image" [ngStyle]="{'margin-top':pageJson?.isDisplayDepositButton ? '0px':'24px'}">
      <img [src]="pageJson.desktopHeaderBanner?.url" [ngStyle]="{'border-radius':pageJson?.isDisplayDepositButton ? '12px 12px 0px 0px':'12px'}" alt="header banner" />
      <div class="btn-content" *ngIf="pageJson?.isDisplayDepositButton">
        <button (click)="redirectPayment()" round-button size="large" filled="filled" color="warn" type="button" i18n>Deposit</button>
      </div>
    </div>
  </ng-container>
  <div *ngIf="!!pageHtml" class="content-wrapper" [ngClass]="[(detectDeviceService.isDesktop()) ? 'desktop': 'mobile']" [innerHtml]="pageHtml"></div>
</div>